<template>
    <div>
      <TopBar />
      <el-container>
        <el-aside width="200px">
          <SideBar />
        </el-aside>
        <el-main>
          <el-row :gutter="20">
            <!-- 视频上传区域 -->
            <el-col :span="16">
              <div class="video-upload">
                <!-- <el-button @click="openUploadModal">上传视频</el-button>
                <video v-if="videoUploaded" controls></video> -->
                <img src="../assets/sp.png" alt="视频图" class="img0">

              </div>
            </el-col>
            <!-- 课堂签到和学生课堂行为 -->
            <el-col :span="8">
              <div class="class-signin">
                <h3>课堂签到</h3>
                <!-- 模拟签到数据 -->
                 <img src="../assets/qiandao.png" alt="签到图" class="img1">
              </div>
              <div class="student-behavior">
                  <h3>学生课堂行为</h3>
                  <div class="performance-list" style="width: 100%;"> <!-- 可调整宽度 -->
                    <div class="performance-item">
                      <div class="performance-value">11</div>
                      <div class="performance-label">互动次数</div>
                    </div>
                    <div class="performance-item">
                      <div class="performance-value">2</div>
                      <div class="performance-label">发言次数</div>
                    </div>
                    <div class="performance-item">
                      <div class="performance-value">0</div>
                      <div class="performance-label">瞌睡次数</div>
                    </div>
                    <div class="performance-item">
                      <div class="performance-value">0.7</div>
                      <div class="performance-label">抬头率</div>
                    </div>
                  </div>
                </div>

                    
                 
            </el-col>
          </el-row>
          <el-row :gutter="20" class="charts-row">
            <!-- 课堂互动分布 -->
            <el-col :span="8">
              <h3>课堂互动分布</h3>
              <!-- 模拟互动分布图表 -->
              <div ref="chartDom3" style="width: 400px; height: 300px;"></div>


            </el-col>
            <!-- 教师分析图表 -->
            <el-col :span="16">
              <el-tabs v-model="activeTab">
                <el-tab-pane label="教师注意力分析" name="attention" style="font-weight: bold; font-size: 32px;">
                  <!-- 模拟注意力分析图表 -->
             
              <div ref="chartDom1" style="width: 900px; height: 300px;"></div>

                </el-tab-pane>
                <el-tab-pane label="教师授课相关度分析" name="relevance" style="font-weight: bold; font-size: 32px;">
                  <!-- 模拟授课相关度分析图表 -->
              <!-- <img src="../assets/xgdfx.png" alt="相关度分析图" class="img1"> -->
              <div ref="chartDom2" style="width: 900px; height: 300px;"></div>


                </el-tab-pane>
              </el-tabs>
            </el-col>
          </el-row>
        </el-main>
      </el-container>


      <!-- 视频上传弹窗 -->
        <el-dialog title="导入视频" :visible.sync="uploadDialogVisible">
            <el-form>
            <el-form-item label="视频">
                <el-upload action="/upload" list-type="text">
                <el-button type="primary">选择视频</el-button>
                </el-upload>
            </el-form-item>
            
            <el-form-item label="学院">
                <el-select v-model="college" placeholder="请选择学院">
                <el-option label="学院1" value="1"></el-option>
                <el-option label="学院2" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="课堂">
                <el-select v-model="classroom" placeholder="请选择课堂">
                <el-option label="课堂1" value="1"></el-option>
                <el-option label="课堂2" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="老师">
                <el-select v-model="teacher" placeholder="请选择老师">
                <el-option label="老师1" value="1"></el-option>
                <el-option label="老师2" value="2"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="选择功能: ">
                <el-checkbox-group v-model="selectedFunctions">
                <el-checkbox label="课堂签到" name="type"></el-checkbox>
                <el-checkbox label="学生课堂行为" name="type"></el-checkbox>
                <el-checkbox label="课堂互动分布" name="type"></el-checkbox>
                <el-checkbox label="教师注意力分析" name="type"></el-checkbox>
                <el-checkbox label="教师授课相关度分析" name="type"></el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            
            </el-form>
            <div slot="footer">
            <el-button @click="uploadDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitUpload">提交</el-button>
            </div>
        </el-dialog>
    </div>
  
   
  </template>
  
  <script>
  import SideBar from '../components/SideBar.vue';
  import TopBar from '../components/TopBar.vue';
  import * as echarts from 'echarts';
import {  chartOption1, chartOption2, chartOption3 } from '../chartsConfig2'; // 引入数据和配置
  
  export default {
    name: 'HomePage',
    components: { SideBar, TopBar },
    data() {
      return {
        videoUploaded: false, // 是否上传了视频
        uploadDialogVisible: false, // 控制上传弹窗
        activeTab: 'attention', // 活跃的标签页
        college: null ,// 选择的学院
        classroom: null,
        teacher: null,
        selectedFunctions: [], // 用于存储选中的功能选项
        // interactionCount: 0, // 互动次数
        // speakingCount: 0,
        // sleepingCount: 0,
        // headUpRate: 0  
       myChart1: null,
       myChart2: null,
       myChart3: null

    }; 
    },
      mounted() {
      this.initCharts();
    },
      beforeDestroy() {
        this.disposeAllCharts();
      },
    methods: {
      // 数据图
      initCharts() {
      this.initChart1();
      this.initChart2();
      this.initChart3();
    },
      initChart1() {
        const chartDom1 = this.$refs.chartDom1;
        if (chartDom1) {
          this.myChart1 = echarts.init(chartDom1);
          this.myChart1.setOption(chartOption1);
        } else {
          console.error('Chart DOM element 1 not found');
        }
      },
      initChart2() {
        const chartDom2 = this.$refs.chartDom2;
        if (chartDom2) {
          this.myChart2 = echarts.init(chartDom2);
          this.myChart2.setOption(chartOption2);
        } else {
          console.error('Chart DOM element 2 not found');
        }
      },
      initChart3() {
        const chartDom3 = this.$refs.chartDom3;
        if (chartDom3) {
          this.myChart3 = echarts.init(chartDom3);
          this.myChart3.setOption(chartOption3);
        } else {
          console.error('Chart DOM element 3 not found');
        }
      },
      disposeAllCharts() {
        if (this.myChart1) {
          this.myChart1.dispose();
        }
        if (this.myChart2) {
          this.myChart2.dispose();
        }
        if (this.myChart3) {
          this.myChart3.dispose();
        }
      },
      

      openUploadModal() {
        this.uploadDialogVisible = true;
      },
      submitUpload() {
      // 模拟提交逻辑
      console.log("学院:", this.college);
      console.log("课堂:", this.classroom);
      console.log("老师:", this.teacher);
      console.log("选中的功能:", this.selectedFunctions);
      this.uploadDialogVisible = false; // 关闭对话框
    }
    }
  };
  </script>
  
  <style scoped>

  
  .video-upload {
    border: 1px solid #e4e4e4;
    padding: 20px;
    text-align: center;
    height: 400px;
    background-color: rgb(214, 237, 237);
  }
  .class-signin, .student-behavior, .charts-row {
    margin-top: 20px;
  }
  .class-signin{
    height: 240px;
    /* background-color: pink; */
  }
  .student-behavior{
    height: 140px;
    /* background-color: lightblue; */
  }
  .img0{
    width: 100%;
    height: 100%;
  }
  .img1{
    width: 100%;
    height: 90%;
  }
.img3{
    width: 100%;    
    height: 350px;
}
/* 数据项布局和样式 */
/* .performance-list {
  display: grid;
  grid-template-columns: repeat(6, 1fr); 
  gap: 10px;
  text-align: center;
} */

.performance-list {
  display: flex;
  flex-wrap: nowrap; /* 防止子元素换行 */
  gap: 10px; /* 子元素之间的间距 */
  text-align: center;
}

/* 数字样式 */
.performance-value {
  font-size: 36px; /* 数字较大 */
  font-weight: bold;
}
.performance-item:nth-child(1) .performance-value {
  color: #ff5733; /* 第1个数字的颜色 - 橙色 */
}

.performance-item:nth-child(2) .performance-value {
  color: #33c3ff; /* 第2个数字的颜色 - 浅蓝色 */
}

.performance-item:nth-child(3) .performance-value {
  color: #33ff57; /* 第3个数字的颜色 - 绿色 */
}

.performance-item:nth-child(4) .performance-value {
  color: #ff33a1; /* 第4个数字的颜色 - 粉色 */
}
/* 标签文字样式 */
.performance-label {
  font-size: 24px;
  color: #888; /* 灰色 */
}

  </style>